<template>
  <div class="chat__input flex p-4 bg-white wrapper msg-input-wrapper">
    <!-- {{UserActiveThread}} -->
    <!-- <div>{{pusher_event_name}}</div> -->
    <vs-row vs-justify="center" vs-align="center">
      
         <vs-textarea
          class="flex-1 w-100 mb-0"
          label="Type Your Message"
          v-model="messageText"
          @keypress.exact="handleChatBoxKeyEvent($event)"
        />

      <emoji-picker @emoji="append" :search="search">
      <div
        class="emoji-invoker"
        slot="emoji-invoker"
        slot-scope="{ events: { click: clickEvent } }"
        @click.stop="clickEvent"
      >
        <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 0h24v24H0z" fill="none"/>
          <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z"/>
        </svg>
      </div>
      <div slot="emoji-picker" slot-scope="{ emojis, insert, display }">
        <div class="emoji-picker" >
          <!-- <div class="" > -->
          <!-- Emoji 1 -->
          <div class="emoji-picker__search">
            <input type="text" v-model="search" v-focus>
          </div>
          <div>
            <div v-for="(emojiGroup, category) in emojis" :key="category">
              <h5>{{ category }}</h5>
              <div class="emojis">
                <span
                  v-for="(emoji, emojiName) in emojiGroup"
                  :key="emojiName"
                  @click="insert(emoji)"
                  :title="emojiName"
                >{{ emoji }}</span>
              </div>
            </div>
          </div>
          <!-- Emoji 2 -->
          <!-- <VEmojiPicker @select="selectEmoji" /> -->
        </div>
      </div>
    </emoji-picker>

        <!-- File Attatchment Icon -->
        <vs-tooltip color="primary" text="Add File" position="top" class="file-attachment-tooltip">
          <vs-button class="file-attachment" radius type="border" icon="attach_file" @click="popupActivo=true;ShowVueFileAgent=false;accept='test'"></vs-button>
          <!-- <span class="material-icons file-attachment" @click="popupActivo=true;ShowVueFileAgent=false;accept='test'">attach_file</span> -->
        </vs-tooltip>
        
        <!-- Chat Send Icon -->
        <vs-tooltip color="primary" text="Send" position="top">
          <vs-button radius class="bg-primary-gradient ml-4" type="filled"  icon="send" @click="sendMsg"/>
        </vs-tooltip>
    </vs-row>

      <div class="centerx">
    <vs-popup class="holamundo"  title="Select file type" :active.sync="popupActivo">
      <!-- <h6 class="text-center mb-10">Select file type</h6> -->
      <vs-row
        vs-align="center"
        vs-type="flex" vs-justify="center" vs-w="12">
        <vs-col class="p-2" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="12">
          <div class="file-type" @click="changeFileUploadType('image/*')">
          <vs-card class="text-center content_mb_0 mb-0" :class="{active:isFileTypeActive('image/*')}">
            <i class="material-icons" style="color:#5f6ba0">image</i>
            <p>Image</p>
          </vs-card>
          </div>
        </vs-col>

        <vs-col class="p-2" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="12">
          <div class="file-type" @click="changeFileUploadType('video/*')">
          <vs-card class="text-center content_mb_0 mb-0" :class="{active:isFileTypeActive('video/*')}">
            <i class="material-icons" style="color:crimson">ondemand_video</i>
            <p>Video</p>
          </vs-card>
          </div>
        </vs-col>

        <vs-col class="p-2" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="12">
          <div class="file-type" @click="changeFileUploadType('audio/*')">
          <vs-card class="text-center content_mb_0 mb-0" :class="{active:isFileTypeActive('audio/*')}">
            <i class="material-icons" style="color:burlywood">audiotrack</i>
            <p>Audio</p>
          </vs-card>
           </div>
        </vs-col>
        
        <vs-col class="p-2" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="12" style="position:relative">
          <div class="file-type doc-type" @click="changeFileUploadType('.xlsx, .xls, .doc, .docx, .ppt, .pptx, .txt, .pdf')">
          <vs-card class="text-center content_mb_0 mb-0" :class="{active:isFileTypeActive('.xlsx, .xls, .doc, .docx, .ppt, .pptx, .txt, .pdf')}">
            <i class="material-icons" style="color:teal">assessment</i>
            <p>Document</p>
            <span class="file-type-tooltip">.xlsx, .xls, .doc, .docx, .ppt, .pptx, .txt, .pdf</span>
          </vs-card>
           </div>
        </vs-col>

        <vs-col class="p-2" vs-type="flex" vs-justify="center" vs-align="center" vs-lg="4" vs-sm="12">
          <div class="file-type" @click="changeFileUploadType('*')">
          <vs-card class="text-center content_mb_0 mb-0" :class="{active:isFileTypeActive('')}">
            <i class="material-icons" style="color:teal">file_present</i>
            <p>Other Files</p>
          </vs-card>
           </div>
        </vs-col>
      </vs-row>

      <vs-divider class="mb-5"/>
      <!-- {{openFileInput}} -->
      <!-- {{file_repository_id}} -->
      <!-- {{accept}} -->
      <!-- {{helpText}} -->
      <!-- {{attachment_ids}} -->
      <div class="cstm_vuefileagent_holder">
      <VueFileAgent
      class="chat-vue-file-agent"
      @switchOffOpenFileInput="openFileInput = false"
      :openFileInput="openFileInput"
      :helpText="helpText"
      :accept="accept"
      module_name="Chat"
      :multiple="true"
      theme="grid"
      @upload-chat-file="handleFileUpload($event)"
      @fileSelected="ShowVueFileAgentFn($event)"
      :class="{'height-auto':this.ShowVueFileAgent}">
      </VueFileAgent>

      <div class="file_uplaod_other_options text-center">
      <p class="or_text_holder mt-4">(or)</p>
      <vs-tooltip class="inline-block align-bottom" color="primary"
      text="Import system files"
      >
        <vs-button
        icon="folder_special"
        class="mb-6 mx-1 icon_large_btn" 
        color="primary"
        type="border"
        @click="isBrowseContent = true"
        ></vs-button
      >
      </vs-tooltip>

      <vs-tooltip class="inline-block align-bottom" color="primary"
      text="Import Google Drive files"
    > 
    <!-- <pre>{{file_id_payload}}</pre> -->
      <vs-button
        class="mb-6 mx-1 icon_large_btn includeIcon includeIconOnly"
        color="primary"
        type="border"
        @click="driveIconClicked()"
        >
        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" enable-background="new 0 0 32 32" height="32px" id="Layer_1" version="1.0" viewBox="0 0 32 32" width="32px" xml:space="preserve"><g><polyline fill="#537ABD" points="31.868,21 9.868,21 4.868,30 26.556,30  "/><polyline fill="#2EB672" points="10.962,2 -0.038,20 4.962,30 15.683,10.345  "/><polyline fill="#FED14B" points="20.962,2 10.962,2 21.712,21 31.962,21 20.962,2  "/></g></svg>
      </vs-button>
    </vs-tooltip>
      </div>
      </div>

    </vs-popup>
  </div>

    <div v-if="isBrowseContent">
      <vs-popup fullscreen title="Browse Item" :active.sync="isBrowseContent"
      class="browse_modal_item"
      >
      <!-- file_repository_id : {{file_repository_id}} -->
        <import-browse-files-model
          v-if="isBrowseContent"
          :file_repository_id="file_repository_id"
          @getImportFile="getImportFile"
          :multipleSelect="multipleSelect"
        ></import-browse-files-model>
        <!-- <div slot="footer">jfjfjf</div> -->
      </vs-popup>
    </div>

  </div>
</template>
<script>

import EmojiPicker from 'vue-emoji-picker'
import { VEmojiPicker } from 'v-emoji-picker'
import {mapActions, mapGetters} from 'vuex'
import { sendMessage, fetchChatHistory, getRepositoryDetails, uploadChatFile, addFileUpload } from '@/api/message'
import {messageMixin} from './mixin/messageMixin'
import {EventBus} from './mixin/EventBus'
import Pusher from 'pusher-js'

import VueFileAgent from '@/components/VueFileAgent/VueFileAgent'
import ImportBrowseFilesModel from '@/components/common/ImportBrowseFilesModel.vue'
import {GoogleAuthorization} from '@/mixins/common/GoogleAuthorization.js'


export default {
  name: 'ChatInput',
  data () {
    return {
      multipleSelect:true,
      isBrowseContent: false,
      openFileInput:false,
      ShowVueFileAgent:false,
      helpText:'Choose image file',
      accept:'test',
      messageText: '',
      messageTextUrl: '',
      file_repository_id: '',
      attachment_ids:[],
      is_attachment:0,
      activeTab:0,
      input: '',
      search: '',
      popupActivo:false
    }
  },
  mixins:[messageMixin, GoogleAuthorization],
  components: {
    sendMessage,
    EmojiPicker,
    VEmojiPicker,
    VueFileAgent,
    ImportBrowseFilesModel
  },
  directives: {
    focus: {
      inserted (el) {
        el.focus()
      }
    }
  },
  
  computed: {
    ...mapGetters(['ChatRelatedTo', 'UserActiveThread', 'ClientActiveThread', 'GroupActiveThread', 'tabActive'])
  },
  created () {
    // this.pusherInitialize()

  },
  mounted () {
    // this.generatePusherEventName()
    this.getRepositoryDetails()
    this.pusherInitialize()
    
  },
  beforeDestroy () {
    //EventBus.$off('newMessageReceived')
    // 
  },
  watch:{
    file_id_payload: {
      deep: true,
      handler () {
        this.sendDriveFiles()
      }
    }
  },
  methods: {
    async sendDriveFiles () {
      const files_to_upload = this.file_id_payload.files

      files_to_upload.forEach(async (value) => {
        const file_name = value.file_name
        const file_path = value.file_path
        const full_file_path = file_path
        const file_extension = value.file_name.split('.').pop()
        try {
          const addFilePayload = {
            'file_repository_id':this.file_repository_id,
            'files': [
              {
                file_name,
                'file_path': full_file_path
              }
            ]
          }
          // console.log('addFileUpload', addFilePayload)
          // console.log('file_extension', file_extension)
          
          const data2 = await addFileUpload(addFilePayload)
          const assignment_id = data2.data.data.files[0].files_id
          this.attachment_ids.push(assignment_id)
          this.messageTextUrl = full_file_path
          this.is_attachment = 1
          this.sendMsg(file_extension)
          this.popupActivo = false
          this.$vs.notify({
            color:'successs',
            title:'Success',
            text:'Sent'
          })
        } catch (e) {
          this.$vs.notify({
            color:'dander',
            title:'error',
            text:'Something went wrong'
          })
        } finally {
          this.$vs.loading.close()
        }
      })

    },
    async getImportFile ({ file_id, fileInfo }) {

      setTimeout(() => {
        this.isBrowseContent = false
        this.showSuccessMessage(
          'Success',
          'File Imported Successfully',
          'success'
        )
      }, 0)

      const files_to_upload = fileInfo
      files_to_upload.forEach(async (value) => {
        const file_name = value.file_name
        const file_path = value.file_path
        const full_file_path = file_path
        // const file_extension = value.name.split('.').pop()
        const file_extension = value.file_type.split('/')[1]
        // 
        // 
        try {
          const addFilePayload = {
            'file_repository_id':this.file_repository_id,
            'files': [
              {
                file_name,
                'file_path': full_file_path
              }
            ]
          }
          // console.log('addFileUpload', addFilePayload)
          // console.log('file_extension', file_extension)
          
          const data2 = await addFileUpload(addFilePayload)
          const assignment_id = data2.data.data.files[0].files_id
          this.attachment_ids.push(assignment_id)
          this.messageTextUrl = full_file_path
          this.is_attachment = 1
          this.sendMsg(file_extension)
          this.popupActivo = false
          this.$vs.notify({
            color:'successs',
            title:'Success',
            text:'Sent'
          })
        } catch (e) {
          this.$vs.notify({
            color:'dander',
            title:'error',
            text:'Something went wrong'
          })
        } finally {
          this.$vs.loading.close()
        }
      })
    },
    pusherInitialize () {
      
      // Enable pusher logging - don't include this in production
      // Pusher.logToConsole = true
      const VUE_APP_PUSHER_APP_KEY = process.env.VUE_APP_PUSHER_APP_KEY
      console.log('VUE_APP_PUSHER_APP_KEY', VUE_APP_PUSHER_APP_KEY)
      console.log('Pusher Initialized')
      console.log(this.pusher_event_name)
      // const current_user_id = JSON.parse(localStorage.getItem('userInfo')).id
      // const id = this.tabActive === 0 ? this.UserActiveThread : this.tabActive === 1 ? this.ClientActiveThread : this.GroupActiveThread
      // const event_name = this.tabActive === 0 ? `chat_${id}_User` : this.tabActive === 1 ? `chat_${id}_Client` : `group_${id}`
      const pusher = new Pusher(VUE_APP_PUSHER_APP_KEY, {
        encrypted: true,
        cluster: 'ap2'
      })
      
      // const channel_name = (this.tabActive === 0 || this.tabActive === 1) ? 'chat' : 'group' 
      const channel_name = 'chat'
      const event_name = 'chat_event'

      console.log('Channel Name:', channel_name)
      console.log('Event Name:', event_name)
      const channel = pusher.subscribe(channel_name)
      
      // if (window.console && window.
      //   window.
      // }
      channel.bind(event_name, function (data) {
        // 
        // EventBus.$off('newMessageReceived', data)
        EventBus.$emit('newMessageReceived', data)
      })
    },
    ShowVueFileAgentFn (event) {
      if (event.length > 0) {
        this.ShowVueFileAgent = true
      }
      
    },
    async handleFileUpload (event) {
      try {
        // this.$vs.loading()
        this.attachment_ids = []
        this.messageText = ''
        this.messageTextUrl = ''
        // 
        // 
        const files_to_upload = event.map((file) => {
          return file.file
        })
        // 
        files_to_upload.forEach(async (value) => {
          
          const formData = new FormData()
          formData.append('files[]', value)
          const customer_id = localStorage.getItem('customer_id')
          const data = await uploadChatFile(customer_id, formData)
          // 
          const cdn = data.data.data.cdn
          const files = data.data.data.files
          const file_name = files[0].file_name
          const file_path = files[0].file_path
          const full_file_path = `${cdn}${file_path}`
          const file_extension = value.name.split('.').pop()
          // 
          // 
          try {
            const addFilePayload = {
              'file_repository_id':this.file_repository_id,
              'files': [
                {
                  file_name,
                  'file_path': full_file_path
                }
              ]
            }
            const data2 = await addFileUpload(addFilePayload)
            // 
            // 
            // 
            const assignment_id = data2.data.data.files[0].files_id
            this.attachment_ids.push(assignment_id)
            this.messageTextUrl = full_file_path

            this.is_attachment = 1
            this.sendMsg(file_extension)
            this.popupActivo = false
          } catch (e) {
            
            this.$vs.notify({
              color:'dander',
              title:'error',
              text:'Something went wrong'
            })
          } finally {
            this.$vs.loading.close()
          }
        })
      } catch (e) {
        
        this.$vs.notify({
          color:'dander',
          title:'error',
          text:'Something went wrong'
        })
      } finally {
        this.$vs.loading.close()
      }
    },
    async getRepositoryDetails () {
      const payload = {
        platform_module_id:'39'
      }
      const customer_id = localStorage.getItem('customer_id')
      const data = await getRepositoryDetails(customer_id, payload)
      // 
      // 
      this.file_repository_id = data.data.data[0].id
    },
    changeFileUploadType (file_type) {
      // this.ShowVueFileAgent = false
      this.accept = file_type
      this.openFileInput = false
      this.openFileInput = !this.openFileInput
      if (file_type === 'image/*') {
        this.helpText = 'Choose image file'
      } else if (file_type === 'video/*') {
        this.helpText = 'Choose video file'
      }  else if (file_type === 'audio/*') {
        this.helpText = 'Choose audio file'
      }  else if (file_type === '.xlsx, .xls, .doc, .docx, .ppt, .pptx, .txt, .pdf') {
        this.helpText = 'Choose document file'
      }  else if (file_type === '*') {
        this.helpText = ''
        this.accept = ''
      }
      // 
    },

    isFileTypeActive (file_type) {
      if (this.accept === file_type) {
        return true
      }
    },
    selectEmoji (emoji) {
      this.messageText += emoji.data
    },
    append (emoji) {
      this.messageText += emoji
    },
    insert (emoji) {
      this.messageText += emoji
    },
    handleChatBoxKeyEvent (event) { 
      // 13 is the keycode for "enter" 
      if (event.keyCode === 13 && event.shiftKey) { 
        this.messageText = `${this.messageText}\n`
        // 
      } else if (event.keyCode === 13 && !event.shiftKey) { 
        // 
        this.sendMsg()
      } 
    },
    async sendMsg (file_extension) {
      try {
        this.activeTab = this.tabActive
        let user_id = null
        let group_id = null
        let to_user_type = ''
        if (this.activeTab === 0) {
          user_id = this.UserActiveThread
          to_user_type = 'User'
        } else if (this.activeTab === 1) {
          user_id = this.ClientActiveThread
          to_user_type = 'Client'
        } else if (this.activeTab === 2) {
          group_id = this.GroupActiveThread
          to_user_type = 'Client'
        }

        let payload = ''
        if (this.activeTab === 2) {
          payload = {
            to_user : null,
            from_user_type : 'User',
            group_name: null,
            group_id,
            message : this.is_attachment === 0 ? this.messageText : this.messageTextUrl,
            to_user_type: null,
            is_attachment: this.is_attachment,
            attachment_type: file_extension,
            attachment_ids: this.attachment_ids,
            is_client_message_type: this.ChatRelatedTo
          }
        } else {
          payload = {
            to_user : user_id,
            from_user_type : 'User',
            group_name: null,
            group_id: null,
            message : this.is_attachment === 0 ? this.messageText : this.messageTextUrl,
            to_user_type,
            is_attachment: this.is_attachment,
            attachment_type:  file_extension,
            attachment_ids: this.attachment_ids,
            is_client_message_type: this.ChatRelatedTo
          }
        }

        const customer_id = localStorage.getItem('customer_id')
        payload.customer_id = customer_id
        // 
        // eslint-disable-next-line no-unused-vars
        const data = await sendMessage(payload)

        EventBus.$emit('chatSentEvent', true)
        // 

        try {

          let payload2 = ''
          if (this.activeTab === 2) {

            payload2 = {
              another_user_id : user_id,
              from_user_type : 'User',
              group_id,
              last_id : null,
              to_user_type,
              is_client_message_type: this.ChatRelatedTo,
              customer_id:localStorage.getItem('customer_id')
            }

          } else {
            payload2 = {
              another_user_id : user_id,
              from_user_type : 'User',
              group_id,
              last_id : null,
              to_user_type,
              is_client_message_type: this.ChatRelatedTo,
              customer_id:localStorage.getItem('customer_id')
            }
          }
          const data2  = await fetchChatHistory(payload2)
          EventBus.$emit('singleChatClicked', data2.data.data)
          this.messageText = ''

        } catch (e) {
          
        }
      } catch (e) {
        
      } finally {
        this.attachment_ids = []
        this.is_attachment = 0
        this.ShowVueFileAgent = false
      }
    }
  }
}
</script>


<style>
.wrapper {
  position: relative;
  display: inline-block;
}

.regular-input {
  padding: 0.5rem 1rem;
  border-radius: 3px;
  border: 1px solid #ccc;
  width: 20rem;
  height: 12rem;
  outline: none;
}

.regular-input:focus {
  box-shadow: 0 0 0 3px rgba(66,153,225,.5);
}

.emoji-invoker {
  position: absolute;
  right: 8rem;
  top: 18px;
  width: 1.5rem;
  height: 1.5rem;
  border-radius: 50%;
  cursor: pointer;
  transition: all 0.2s;
}
.emoji-invoker:hover {
  transform: scale(1.1);
}
.emoji-invoker > svg {
  fill: #b1c6d0;
}

.emoji-picker {
    position: absolute;
    border-radius: 8px;
    padding: 11px;
    background: white;
    box-shadow: 0px 0px 25px #d5cccc;
    font-family: Montserrat;
    width: 84%;
    height: 20rem;
    top: -268px;
    right: 100px;
    overflow-x: hidden;
    overflow-y: auto;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
.emoji-picker__search {
  display: flex;
}
.emoji-picker__search > input {
  flex: 1;
  border-radius: 10rem;
  border: 1px solid #ccc;
  padding: 0.5rem 1rem;
  outline: none;
}
.emoji-picker h5 {
  margin-bottom: 0;
  color: #b1b1b1;
  text-transform: uppercase;
  font-size: 0.8rem;
  cursor: default;
}
.emoji-picker .emojis {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
}
.emoji-picker .emojis:after {
  content: "";
  flex: auto;
}
.emoji-picker .emojis span {
    background: #e7e6e736;
    padding: 0.2rem;
    cursor: pointer;
    border-radius: 5px;
    margin: 2px;
    font-size: 23px;
}
.emoji-picker .emojis span:hover {
  background: #ececec;
  cursor: pointer;
}

.file-attachment .material-icons {  
  cursor: pointer;
  font-size: 18px;  
}
.file-attachment-tooltip{
  position: relative;
  left: 8px;
}

.file-type{
  cursor: pointer;
  width:100%;
}

.file-type .vs-card--content:hover{
  background-color:#8de2eb;
  border-radius: 8px;
}

.file-type .active{
  background-color:#8de2eb;
}

.chat-vue-file-agent{
  height:0px;
  overflow: auto;

}
.height-auto{
  height:auto
}

.chat-vue-file-agent .vue-file-agent.file-input-wrapper{

    border: 0px;
    box-shadow: 0px 0px 5px #80808054;
}
.file-type-tooltip{
  position: absolute;
  background: white;
  bottom: -60px;
  width: 100%;
  left: 50%;
  transform: translateX(-50%);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.5);
  border-radius: 5px;
  /* font-style: italic; */
  transition: all 0.3s;
  padding: 5px;
  display: none;
}

.doc-type:hover .file-type-tooltip{
  display: block;
}

@media only screen and (max-width: 768px) {
    .emoji-picker {
      width:76.5%
    }
}
</style>